import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {IdentificationServiceRequest} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormFramework from './InnerFormDocsId';
import {FieldShape} from 'commons/shapes';
import {formValidator} from 'commons/utils/Functions';
import {INE_ID, Messages} from 'commons/constants';

DocsIdForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    docsIdentification: PropTypes.any,
    foreign: PropTypes.bool,
    editing: PropTypes.bool
};

const FormControl = withFormik<
    InferPropTypes<typeof DocsIdForm.propTypes>,
    IdentificationServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            identificationType: '',
            identificationNumber: '',
            kycId: '',
            otherIdentificationType: '',
            otherIdentificationNumber: '',
            issuingAuthority: '',
            dniFront: '',
            dniBack: '',
        };
    },
    mapPropsToValues: (props) => {
        const {docsIdentification} = props;
        if (docsIdentification) {
            return {
                identificationType: docsIdentification.identificationType || '',
                identificationNumber: docsIdentification.identificationNumber || '',
                kycId: docsIdentification.kycId || 0,
                otherIdentificationType: docsIdentification.otherIdentificationType || '',
                otherIdentificationNumber: docsIdentification.otherIdentificationNumber || '',
                issuingAuthority: docsIdentification.issuingAuthority || '',
                dniFront: docsIdentification.dniFront || '',
                dniBack: docsIdentification.dniBack || '',
            };
        } else {
            return {
                identificationType: '',
                identificationNumber: '',
                kycId: 0,
                otherIdentificationType: '',
                otherIdentificationNumber: '',
                issuingAuthority: '',
                dniFront: '',
                dniBack: '',
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: IdentificationServiceRequest, props) => {
        const errors: FormikErrors<IdentificationServiceRequest> = {};
        formValidator(props.fields, errors, values);
        if (!values.dniFront) {
            errors.dniFront = props.foreign ? Messages.DNI_MISSING : Messages.DNI_FRONT_MISSING;
        }
        if (!values.dniBack && !props.foreign) {
            errors.dniBack = Messages.DNI_BACK_MISSING;
        }
        if (
            values.identificationType &&
            values.identificationType === values.otherIdentificationType &&
            values.identificationType !== INE_ID
        ) {
            errors.otherIdentificationType = Messages.IDENTIFICATION_DUPLICATED;
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormFramework);

function DocsIdForm(props: InferPropTypes<typeof DocsIdForm.propTypes>) {
    const {submitHandler, fields, docsIdentification, foreign, editing} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            fields={fields}
            submitHandler={submitHandler}
            docsIdentification={docsIdentification}
            foreign={foreign}
            editing={editing}
        />
    );
}

export default DocsIdForm;
